<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/percent.svg?raw'
export default {
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
